export const BankData = [
  { bank_name: "Bank Pembangunan Daerah Aceh", channel_code: "ACEH" },
  {
    bank_name: "Bank Pembangunan Daerah Aceh Syariah",
    channel_code: "ACEH_UUS",
  },
  {
    bank_name: "Bank BRI Agroniaga",
    channel_code: "AGRONIAGA",
  },
  {
    bank_name: "Bank Aladin Syariah",
    channel_code: "ALADIN",
  },
  {
    bank_name: "Allo Bank Indonesia",
    channel_code: "ALLO",
  },
  {
    bank_name: "Bank Amar Indonesia",
    channel_code: "AMAR",
  },
  {
    bank_name: "Bank ANZ Indonesia",
    channel_code: "ANZ",
  },
  {
    bank_name: "Bank Artha Graha International",
    channel_code: "ARTHA",
  },
  {
    bank_name: "Bank Pembangunan Daerah Bali",
    channel_code: "BALI",
  },
  {
    bank_name: "Bank of America Merill-Lynch",
    channel_code: "BAML",
  },
  {
    bank_name: "Bank Pembangunan Daerah Banten",
    channel_code: "BANTEN",
  },
  {
    bank_name: "Bank Central Asia (BCA)",
    channel_code: "BCA",
  },
  {
    bank_name: "Bank Central Asia Digital (BluBCA)",
    channel_code: "BCA_DIGITAL",
  },
  {
    bank_name: "Bank Central Asia (BCA) Syariah",
    channel_code: "BCA_SYR",
  },
  {
    bank_name: "Bank Pembangunan Daerah Bengkulu",
    channel_code: "BENGKULU",
  },
  {
    bank_name: "Bank Bisnis Internasional",
    channel_code: "BISNIS_INTERNASIONAL",
  },
  {
    bank_name: "Bank BJB",
    channel_code: "BJB",
  },
  {
    bank_name: "Bank BJB Syariah",
    channel_code: "BJB_SYR",
  },
  {
    bank_name: "Bank Neo Commerce",
    channel_code: "BNC",
  },
  {
    bank_name: "Bank Negara Indonesia (BNI)",
    channel_code: "BNI",
  },
  {
    bank_name: "Bank BNP Paribas",
    channel_code: "BNP_PARIBAS",
  },
  {
    bank_name: "Bank of China (BOC)",
    channel_code: "BOC",
  },
  {
    bank_name: "Bank Rakyat Indonesia (BRI)",
    channel_code: "BRI",
  },
  {
    bank_name: "Bank Syariah Indonesia (BSI)",
    channel_code: "BSI",
  },
  {
    bank_name: "Bank Tabungan Negara (BTN)",
    channel_code: "BTN",
  },
  {
    bank_name: "Bank Tabungan Negara Syariah",
    channel_code: "BTN_UUS",
  },
  {
    bank_name: "BTPN Syariah",
    channel_code: "BTPN_SYARIAH",
  },
  {
    bank_name: "Bank Bukopin",
    channel_code: "BUKOPIN",
  },
  {
    bank_name: "Bank Syariah Bukopin",
    channel_code: "BUKOPIN_SYR",
  },
  {
    bank_name: "Bank Bumi Arta",
    channel_code: "BUMI_ARTA",
  },
  {
    bank_name: "Bank Capital Indonesia",
    channel_code: "CAPITAL",
  },
  {
    bank_name: "China Construction Bank Indonesia",
    channel_code: "CCB",
  },
  {
    bank_name: "Bank Chinatrust Indonesia",
    channel_code: "CHINATRUST",
  },
  {
    bank_name: "Bank CIMB Niaga",
    channel_code: "CIMB",
  },
  {
    bank_name: "Bank CIMB Niaga Syariah",
    channel_code: "CIMB_UUS",
  },
  {
    bank_name: "Citibank",
    channel_code: "CITIBANK",
  },
  {
    bank_name: "Bank Commonwealth",
    channel_code: "COMMONWEALTH",
  },
  {
    bank_name: "Bank Pembangunan Daerah Daerah Istimewa Yogyakarta",
    channel_code: "DAERAH_ISTIMEWA",
  },
  {
    bank_name: "Bank Pembangunan Daerah Daerah Istimewa Yogyakarta Syariah",
    channel_code: "DAERAH_ISTIMEWA_UUS",
  },
  {
    bank_name: "Bank Danamon",
    channel_code: "DANAMON",
  },
  {
    bank_name: "Bank Danamon Syariah",
    channel_code: "DANAMON_UUS",
  },
  {
    bank_name: "Bank DBS Indonesia",
    channel_code: "DBS",
  },
  {
    bank_name: "Deutsche Bank",
    channel_code: "DEUTSCHE",
  },
  {
    bank_name: "Bank Dinar Indonesia",
    channel_code: "DINAR_INDONESIA",
  },
  {
    bank_name: "Bank DKI",
    channel_code: "DKI",
  },
  {
    bank_name: "Bank DKI Syariah",
    channel_code: "DKI_UUS",
  },
  {
    bank_name: "Bank Fama International",
    channel_code: "FAMA",
  },
  {
    bank_name: "Bank Ganesha",
    channel_code: "GANESHA",
  },
  {
    bank_name: "Bank HANA",
    channel_code: "HANA",
  },
  {
    bank_name: "HSBC Indonesia",
    channel_code: "HSBC",
  },
  {
    bank_name: "Hongkong and Shanghai Bank Corporation Syariah",
    channel_code: "HSBC_UUS",
  },
  {
    bank_name: "Bank IBK Indonesia",
    channel_code: "IBK",
  },
  {
    bank_name: "Bank ICBC Indonesia",
    channel_code: "ICBC",
  },
  {
    bank_name: "Bank Ina Perdania",
    channel_code: "INA_PERDANA",
  },
  {
    bank_name: "Bank Index Selindo",
    channel_code: "INDEX_SELINDO",
  },
  {
    bank_name: "Bank of India Indonesia",
    channel_code: "INDIA",
  },
  {
    bank_name: "Bank Jago",
    channel_code: "JAGO",
  },
  {
    bank_name: "Bank Pembangunan Daerah Jambi",
    channel_code: "JAMBI",
  },
  {
    bank_name: "Bank Pembangunan Daerah Jambi Syariah",
    channel_code: "JAMBI_UUS",
  },
  {
    bank_name: "Bank Jasa Jakarta",
    channel_code: "JASA_JAKARTA",
  },
  {
    bank_name: "Bank Pembangunan Daerah Jawa Tengah",
    channel_code: "JAWA_TENGAH",
  },
  {
    bank_name: "Bank Pembangunan Daerah Jawa Tengah Syariah",
    channel_code: "JAWA_TENGAH_UUS",
  },
  {
    bank_name: "Bank Pembangunan Daerah Jawa Timur",
    channel_code: "JAWA_TIMUR",
  },
  {
    bank_name: "Bank Pembangunan Daerah Jawa Timur Syariah",
    channel_code: "JAWA_TIMUR_UUS",
  },
  {
    bank_name: "JP Morgan Chase Bank",
    channel_code: "JPMORGAN",
  },
  {
    bank_name: "Bank JTrust Indonesia",
    channel_code: "JTRUST",
  },
  {
    bank_name: "Bank Pembangunan Daerah Kalimantan Barat",
    channel_code: "KALIMANTAN_BARAT",
  },
  {
    bank_name: "Bank Pembangunan Daerah Kalimantan Barat Syariah",
    channel_code: "KALIMANTAN_BARAT_UUS",
  },
  {
    bank_name: "Bank Pembangunan Daerah Kalimantan Selatan",
    channel_code: "KALIMANTAN_SELATAN",
  },
  {
    bank_name: "Bank Pembangunan Daerah Kalimantan Selatan Syariah",
    channel_code: "KALIMANTAN_SELATAN_UUS",
  },
  {
    bank_name: "Bank Pembangunan Daerah Kalimantan Tengah",
    channel_code: "KALIMANTAN_TENGAH",
  },
  {
    bank_name: "Bank Pembangunan Daerah Kalimantan Timur",
    channel_code: "KALIMANTAN_TIMUR",
  },
  {
    bank_name: "Bank Pembangunan Daerah Kalimantan Timur Syariah",
    channel_code: "KALIMANTAN_TIMUR_UUS",
  },
  {
    bank_name: "Bank Pembangunan Daerah Lampung",
    channel_code: "LAMPUNG",
  },
  {
    bank_name: "Bank Pembangunan Daerah Maluku",
    channel_code: "MALUKU",
  },
  {
    bank_name: "Bank Mandiri",
    channel_code: "MANDIRI",
  },
  {
    bank_name: "Mandiri Taspen Pos",
    channel_code: "MANDIRI_TASPEN",
  },
  {
    bank_name: "Bank Maspion Indonesia",
    channel_code: "MASPION",
  },
  {
    bank_name: "Bank Mayapada International",
    channel_code: "MAYAPADA",
  },
  {
    bank_name: "Bank Maybank",
    channel_code: "MAYBANK",
  },
  {
    bank_name: "Bank Maybank Syariah Indonesia",
    channel_code: "MAYBANK_SYR",
  },
  {
    bank_name: "Bank Mayora",
    channel_code: "MAYORA",
  },
  {
    bank_name: "Bank Mega",
    channel_code: "MEGA",
  },
  {
    bank_name: "Bank Syariah Mega",
    channel_code: "MEGA_SYR",
  },
  {
    bank_name: "Bank Mestika Dharma",
    channel_code: "MESTIKA_DHARMA",
  },
  {
    bank_name: "Bank Mizuho Indonesia",
    channel_code: "MIZUHO",
  },
  {
    bank_name: "Bank MNC Internasional",
    channel_code: "MNC_INTERNASIONAL",
  },
  {
    bank_name: "Bank Muamalat Indonesia",
    channel_code: "MUAMALAT",
  },
  {
    bank_name: "Bank Multi Arta Sentosa",
    channel_code: "MULTI_ARTA_SENTOSA",
  },
  {
    bank_name: "Bank Nationalnobu",
    channel_code: "NATIONALNOBU",
  },
  {
    bank_name: "Bank Pembangunan Daerah Nusa Tenggara Barat",
    channel_code: "NUSA_TENGGARA_BARAT",
  },
  {
    bank_name: "Bank Pembangunan Daerah Nusa Tenggara Timur",
    channel_code: "NUSA_TENGGARA_TIMUR",
  },
  {
    bank_name: "Bank OCBC NISP",
    channel_code: "OCBC",
  },
  {
    bank_name: "Bank OCBC NISP Syariah",
    channel_code: "OCBC_UUS",
  },
  {
    bank_name: "Bank Oke Indonesia",
    channel_code: "OKE",
  },
  {
    bank_name: "Bank Panin",
    channel_code: "PANIN",
  },
  {
    bank_name: "Bank Panin Syariah",
    channel_code: "PANIN_SYR",
  },
  {
    bank_name: "Bank Pembangunan Daerah Papua",
    channel_code: "PAPUA",
  },
  {
    bank_name: "Bank Permata",
    channel_code: "PERMATA",
  },
  {
    bank_name: "Bank Permata Syariah",
    channel_code: "PERMATA_UUS",
  },
  {
    bank_name: "Prima Master Bank",
    channel_code: "PRIMA_MASTER",
  },
  {
    bank_name: "Bank QNB Indonesia",
    channel_code: "QNB_INDONESIA",
  },
  {
    bank_name: "Bank Rabobank International Indonesia",
    channel_code: "RABOBANK",
  },
  {
    bank_name: "Bank Resona Perdania",
    channel_code: "RESONA",
  },
  {
    bank_name: "Bank Pembangunan Daerah Riau Dan Kepri",
    channel_code: "RIAU_DAN_KEPRI",
  },
  {
    bank_name: "Bank Sahabat Sampoerna",
    channel_code: "SAHABAT_SAMPOERNA",
  },
  {
    bank_name: "Bank SBI Indonesia",
    channel_code: "SBI_INDONESIA",
  },
  {
    bank_name: "Bank Seabank Indonesia",
    channel_code: "SEABANK",
  },
  {
    bank_name: "Bank Shinhan Indonesia",
    channel_code: "SHINHAN",
  },
  {
    bank_name: "Bank Sinarmas",
    channel_code: "SINARMAS",
  },
  {
    bank_name: "Bank Sinarmas Syariah",
    channel_code: "SINARMAS_UUS",
  },
  {
    bank_name: "Standard Charted Bank",
    channel_code: "STANDARD_CHARTERED",
  },
  {
    bank_name: "Bank Pembangunan Daerah Sulawesi Tengah",
    channel_code: "SULAWESI",
  },
  {
    bank_name: "Bank Pembangunan Daerah Sulawesi Tenggara",
    channel_code: "SULAWESI_TENGGARA",
  },
  {
    bank_name: "Bank Pembangunan Daerah Sulselbar",
    channel_code: "SULSELBAR",
  },
  {
    bank_name: "Bank Pembangunan Daerah Sulselbar Syariah",
    channel_code: "SULSELBAR_UUS",
  },
  {
    bank_name: "Bank Pembangunan Daerah Sulut",
    channel_code: "SULUT",
  },
  {
    bank_name: "Bank Pembangunan Daerah Sumatera Barat",
    channel_code: "SUMATERA_BARAT",
  },
  {
    bank_name: "Bank Pembangunan Daerah Sumatera Barat Syariah",
    channel_code: "SUMATERA_BARAT_UUS",
  },
  {
    bank_name: "Bank Pembangunan Daerah Sumsel Dan Babel",
    channel_code: "SUMSEL_DAN_BABEL",
  },
  {
    bank_name: "Bank Pembangunan Daerah Sumsel Dan Babel Syariah",
    channel_code: "SUMSEL_DAN_BABEL_UUS",
  },
  {
    bank_name: "Bank Pembangunan Daerah Sumut",
    channel_code: "SUMUT",
  },
  {
    bank_name: "Bank Pembangunan Daerah Sumut Syariah",
    channel_code: "SUMUT_UUS",
  },
  {
    bank_name: "Bank Tabungan Pensiunan Nasional (BTPN)",
    channel_code: "TABUNGAN_PENSIUNAN_NASIONAL",
  },
  {
    bank_name: "Bank of Tokyo Mitsubishi UFJ",
    channel_code: "TOKYO",
  },
  {
    bank_name: "Bank UOB Indonesia",
    channel_code: "UOB",
  },
  {
    bank_name: "Bank Victoria Internasional",
    channel_code: "VICTORIA_INTERNASIONAL",
  },
  {
    bank_name: "Bank Victoria Syariah",
    channel_code: "VICTORIA_SYR",
  },
  {
    bank_name: "Bank Woori Indonesia",
    channel_code: "WOORI",
  },
];
